var _path, _path2, _path3, _path4, _path5, _path6;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgIllustrationQuick = function SvgIllustrationQuick(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.8538 24.0001C45.8538 21.1959 45.3015 18.4191 44.2283 15.8283C43.1552 13.2375 41.5825 10.8835 39.5994 8.90058C37.6167 6.91767 35.2626 5.34474 32.6718 4.27163C30.081 3.19848 27.3042 2.64615 24.5 2.64615V24.0001H45.8538Z",
    stroke: "#F77A5F",
    strokeWidth: 3.42857,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.07382 24H3.146",
    stroke: "#F59E54",
    strokeWidth: 3.42857,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8703 12.3704L9.38794 8.88806",
    stroke: "#F59E54",
    strokeWidth: 3.42857,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8703 35.6297L9.38794 39.1118",
    stroke: "#F59E54",
    strokeWidth: 3.42857,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 40.4263V45.3538",
    stroke: "#F59E54",
    strokeWidth: 3.42857,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M36.1289 35.6297L39.6113 39.1118",
    stroke: "#F59E54",
    strokeWidth: 3.42857,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

export { SvgIllustrationQuick as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDkiIGhlaWdodD0iNDgiIHZpZXdCb3g9IjAgMCA0OSA0OCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTQ1Ljg1MzggMjQuMDAwMUM0NS44NTM4IDIxLjE5NTkgNDUuMzAxNSAxOC40MTkxIDQ0LjIyODMgMTUuODI4M0M0My4xNTUyIDEzLjIzNzUgNDEuNTgyNSAxMC44ODM1IDM5LjU5OTQgOC45MDA1OEMzNy42MTY3IDYuOTE3NjcgMzUuMjYyNiA1LjM0NDc0IDMyLjY3MTggNC4yNzE2M0MzMC4wODEgMy4xOTg0OCAyNy4zMDQyIDIuNjQ2MTUgMjQuNSAyLjY0NjE1VjI0LjAwMDFINDUuODUzOFoiIHN0cm9rZT0iI0Y3N0E1RiIgc3Ryb2tlLXdpZHRoPSIzLjQyODU3IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTguMDczODIgMjRIMy4xNDYiIHN0cm9rZT0iI0Y1OUU1NCIgc3Ryb2tlLXdpZHRoPSIzLjQyODU3IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTEyLjg3MDMgMTIuMzcwNEw5LjM4Nzk0IDguODg4MDYiIHN0cm9rZT0iI0Y1OUU1NCIgc3Ryb2tlLXdpZHRoPSIzLjQyODU3IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTEyLjg3MDMgMzUuNjI5N0w5LjM4Nzk0IDM5LjExMTgiIHN0cm9rZT0iI0Y1OUU1NCIgc3Ryb2tlLXdpZHRoPSIzLjQyODU3IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTI0LjUgNDAuNDI2M1Y0NS4zNTM4IiBzdHJva2U9IiNGNTlFNTQiIHN0cm9rZS13aWR0aD0iMy40Mjg1NyIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik0zNi4xMjg5IDM1LjYyOTdMMzkuNjExMyAzOS4xMTE4IiBzdHJva2U9IiNGNTlFNTQiIHN0cm9rZS13aWR0aD0iMy40Mjg1NyIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo=";